import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Constantes } from '../../../shared/constant/constantes';
import { SerieEstadistica } from '../../../shared/entities/serie-estadistica';
import { VisualizadorService } from '../../../shared/service/visualizador.service';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

export class NotasFeErratas {
  public id!: number;
  public idSerie!: number;
  public tipo: string = '';
  public descripcion: string = '';
  public estado: string = '';
  public nombreAdjunto: string = '';
  public fecha!: Date;
  public nombreSeccion: string = '';
  public nombrePadre: string = '';
}

export class Metodologia {
  public titulo: string = '';
  public tipo: string = '';
  public lista: Array<any> = new Array();
}

@Component({
  selector: 'app-nota-fe-errata',
  templateUrl: './nota-fe-errata.component.html',
  styleUrls: ['./nota-fe-errata.component.css'],
  standalone: true,
  imports: [CommonModule, CdkAccordionModule, MatIconModule]
})
export class NotaFeErrataComponent implements OnInit {

  public items = ['Fe de erratas', 'Notas metodológicas', 'Metodologías'];
  public listaInformacionSeries: Array<SerieEstadistica> = new Array();
  public informacionSerieSelected: SerieEstadistica = new SerieEstadistica();
  public tipoVisualizacion: string = 'DOCUMENTOS_METODOLOGICOS';
  public listaMetodologia: Array<Metodologia> = new Array();
  public cargando: boolean = true;
  public tituloNotaFeErrata = '';
  public constantes: Constantes = new Constantes();
  public expanded: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<NotaFeErrataComponent>, private service: VisualizadorService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    var metodo: Metodologia = new Metodologia();
    this.cargando = true;
    //this.detalleSerie = this.data.dataKey;
    var parametrosEntrada: any[] = this.data.dataKey;
    this.tipoVisualizacion = parametrosEntrada[1];
    this.listaInformacionSeries = parametrosEntrada[0];
    this.informacionSerieSelected = parametrosEntrada[2];
    if (this.tipoVisualizacion === 'NOTA_ACLARATORIA') {
      this.tituloNotaFeErrata = 'Notas aclaratorias y fe de erratas';
      metodo.titulo = 'Notas aclaratorias y fe de erratas';
      metodo.tipo = 'NOTAS_FE_ERRATAS';
      this.listaInformacionSeries.forEach(serie => {
        //05-JULIO-2024 DESARROLLO PARA GENERAR LAS NOTAS  
        var fde = '';
        var metodoSerie: Metodologia = new Metodologia();
        metodoSerie.titulo = serie.nombre;
        if (serie.metadataNotas != null) {
          var notas: string = '';
          var listaNotas: Array<any> = new Array();
          fde = this.generaNotas(serie.metadataNotas, notas);
          if (fde != null && fde.trim() != '') {
            listaNotas.push(fde);
          }
          metodoSerie.lista = listaNotas;
          metodo.lista.push(metodoSerie);
        }
      });
      this.listaMetodologia.push(metodo);
      this.cargando = false;
    } else {
      this.tituloNotaFeErrata = 'Documentos metodológicos';
      metodo = new Metodologia();
      metodo.titulo = 'Metodologías';
      metodo.tipo = 'METODOLOGIAS';
      var listaAdjuntos: Map<number, string> = new Map();
      this.service.consultaFeErratas(this.informacionSerieSelected.id + '').subscribe({
        next: (jsonResponse) => {
          jsonResponse.forEach((element: NotasFeErratas) => {
            if (listaAdjuntos != null && !listaAdjuntos.has(element.id)) {
              metodo.lista.push(element);
              listaAdjuntos.set(element.id, element.nombreAdjunto);
            }
          });
          if (this.listaMetodologia.length <= 0) {
            this.listaMetodologia.push(metodo);
          }
          this.cargando = false;
        },
        error: (error) => {
          console.log("Error inesperado en consultaFeErratas  ", error);
        }
      });
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }

  abrirEnlace(archivo: string) {
    if (archivo.includes('pdf') && !archivo.includes('https')) {
      this.service.consultaArchivo(archivo)
        .subscribe(dataResponse => {
          var newBlob = new Blob([dataResponse], { type: "application/pdf" });
          const data = window.URL.createObjectURL(newBlob);
          this.service.windowOpen(data, '_blank');
        });
    } else {
      this.service.windowOpen(archivo, '_blank');
    }
  }

  private generaNotas(nfe: any, listaNotas: string): string {
    if (nfe != null && nfe.notas != null && nfe.notas.length > 0) {
      nfe.notas.forEach((element: any) => {
        if (element.estado === 'ACTIVO' && element.tipo != 'NOTA_EXTRA') {
          var n = '';
          for (let i = 0; i < nfe.nivel; i++) {
            n += ' ';
          }
          if (element.tipo === 'NOTA_ACLARATORIA') {
            n += '<li class="li-lista-enlace-guia"><span class="span-nota-fe-errata">Nota aclaratoria: </span>' + element.descripcion + '</li>' + '\n\n';
          } else {
            n += '<li class="li-lista-enlace-guia"><span class="span-nota-fe-errata">Fe de errata: </span>' + element.descripcion + '</li>' + '\n\n';
          }
          listaNotas += n;
        }
      });
    }
    if (nfe != null && nfe.seriesHijas != null && nfe.seriesHijas.length > 0) {
      nfe.seriesHijas.forEach((element: any) => {
        listaNotas = this.generaNotas(element, listaNotas);
      });
    }
    return listaNotas;
  }

}
